import Layout from "../../components/layout";

export default function Terms() {
  return (
      <Layout>

        <div class="terms-wrapper">

    <section class="hero">
      <div class="container">
        <h1 class="title">Terms & Conditions</h1>
        <p class="subtitle">Please read these terms carefully before using our AV services.</p>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <h2 class="heading">1. Services Overview</h2>
        <p>PROSLV provides audio visual design, installation, rental, and live event services. By using our services, you agree to these terms in full.</p>
      </div>
    </section>

    <section class="section alt">
      <div class="container">
        <h2 class="heading">2. Bookings & Payment</h2>
        <p>All bookings must be confirmed in writing. A deposit may be required for event-based services. Final payment is due as per the agreed schedule or upon project delivery.</p>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <h2 class="heading">3. Equipment Use</h2>
        <p>Clients are responsible for AV equipment once delivered or installed. Any damage caused by misuse may incur repair or replacement charges.</p>
      </div>
    </section>

    <section class="section alt">
      <div class="container">
        <h2 class="heading">4. Cancellations</h2>
        <p>Cancellations must be made at least 48 hours in advance for full refund eligibility. Custom installations may incur a restocking fee or partial charge upon cancellation.</p>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <h2 class="heading">5. Intellectual Property</h2>
        <p>All AV content, designs, and technical solutions provided by PROSLV remain our intellectual property unless otherwise agreed upon in writing.</p>
      </div>
    </section>

    <section class="section alt">
      <div class="container">
        <h2 class="heading">6. Liability</h2>
        <p>We are not liable for service interruptions caused by force majeure, venue issues, or equipment failure beyond our control. We always aim for 100% reliability.</p>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <h2 class="heading">7. Contact</h2>
        <p>For questions or concerns, contact us at <a href="mailto:legal@proslv.com">legal@proslv.com</a>.</p>
      </div>
    </section>

  </div>

      </Layout>
  );
}
